import { HugggListContainer } from 'components';
import { PageTitle } from 'components/misc';
import dictionary from 'config/dictionary';
import { useAnalytics } from 'hooks';
import { Layout } from 'layouts';
import React, { useEffect } from 'react';

const MyHugggs = () => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.screenViewedMyHugggs();
  }, [analytics]);

  return (
    <Layout showBackButton={false} title={dictionary.myHugggs.title}>
      <PageTitle title={dictionary.myHugggs.title} />

      <HugggListContainer />
    </Layout>
  );
};

export default MyHugggs;
